import type { FaireProductEntity } from "../../entity_types/product";

export const p_x7k9hpxvg3: FaireProductEntity = {
  token: "p_x7k9hpxvg3",
  type: "product",
  name: "Hand-Cut Honeycomb",
  brandName: "Big Dipper Honey",
  imageUrl:
    "https://cdn.faire.com/fastly/6a6e7533b1205038f64d02141e084f4d8796b61a06790737a32c4ffb44787d86.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b0d3e3cc965a7b6a7bf0263bbf612ffe5877276b13cf4501a374d32a08c2944e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
